

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { TrainingForm } from './training-form/TrainingForm';
import { TrainingFormValues } from '../types';

interface TrainingFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
  onCancel?: () => void;
  initialValues?: Partial<TrainingFormValues>;
  isEditing?: boolean;
  sessionId?: string;
}

export function TrainingFormDialog({
  open,
  onOpenChange,
  onSuccess,
  onCancel,
  initialValues,
  isEditing = false,
  sessionId,
}: TrainingFormDialogProps) {
  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
    onOpenChange(false);
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            {isEditing ? 'Edit Training Session' : 'New Training Session'}
          </DialogTitle>
          <DialogDescription>
            {isEditing 
              ? 'Update your training session details, techniques learned, and notes.'
              : 'Log your training session details, techniques learned, and notes to track your progress.'
            }
          </DialogDescription>
        </DialogHeader>
        <TrainingForm
          initialValues={initialValues}
          onSubmit={handleSuccess}
          isEditing={isEditing}
          sessionId={sessionId}
          onCancel={handleCancel}
        />
      </DialogContent>
    </Dialog>
  );
}
